import React from "react";
import { gql } from "@apollo/client";

import { List, Paper } from "@mui/material";

import Header from "./01-Header";
import Cart from "./02-Cart";
import SoundShaping from "./03-SoundShaping";
import Address from "./04-Address";
import OtherOrders from "./05-OtherOrders";

export default function OrderSidebar({ order }) {
  return (
    <List disablePadding component={Paper}>
      <Header order={order} />
      <Cart order={order} />
      <SoundShaping order={order} />
      <Address order={order} />
      <OtherOrders order={order} />
    </List>
  );
}

OrderSidebar.fragments = {
  order: gql`
    fragment OrderSidebar_order on Order {
      id

      ...Orders_OrderSidebarHeader_Order
      ...OrderSidebar_Cart_order
      ...Orders_OrderSidebarSoundShaping_Order
      ...Orders_OrderSidebarAddress_Order
      ...Orders_OrderSidebarOtherOrders_Order
    }

    ${Header.fragments.order}
    ${Cart.fragments.order}
    ${SoundShaping.fragments.order}
    ${Address.fragments.order}
    ${OtherOrders.fragments.order}
  `,
};
